import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import type { ChatBranchSubmitPreference } from '@terra/shared-dto-chat-types';
import { createTenantStorage } from './tenantStorage';

type CopilotBranchPreferencesState = {
  submitPreference: ChatBranchSubmitPreference;
  setSubmitPreference: (preference: ChatBranchSubmitPreference) => void;
};

const STORAGE_KEY = 'copilot-branch-submit-preference';

export const useCopilotBranchPreferencesStore =
  create<CopilotBranchPreferencesState>()(
    persist(
      (set) => ({
        submitPreference: 'ask',
        setSubmitPreference: (submitPreference) => set({ submitPreference }),
      }),
      {
        name: STORAGE_KEY,
        storage: createJSONStorage(() => createTenantStorage()),
        partialize: (state) => ({ submitPreference: state.submitPreference }),
      },
    ),
  );
